export default function getContestApiRoot(): string {
  return `${process.env.REACT_APP_PROMOTIONS_MOCK_API === 'true'
    ? '/api'
    : process.env.REACT_APP_PROMOTIONS_API_ROOT ?? '/api'}/omni/promotions/v2/contests`;
}
